import { APICompsSchema } from "../api-config";

export const flatAddressObject = (): APICompsSchema["FlatAddressObject"] => {
  return {
    id: "",
    postCode: "",
    countryCode: "",
    // 新規作成フォームの初期値になるため未選択で始める。
    // 「北海道」を既定にすると SelectPrefecture の「都道府県を選択してください」が一度も出ず、
    // 触り忘れても必須エラーにならないまま北海道として保存できてしまう（#1527）。
    // PrefectureEnum に未選択の値は無いので、フォーム側の `prefecture || "none"` /
    // `!prefecture` の分岐に合わせて空文字を入れる。
    prefecture: "" as APICompsSchema["PrefectureEnum"],
    city: "",
    street: "",
    building: null,
    mapUrl: null,
    latLng: null,
    createdAt: 0,
    updatedAt: 0,
  };
};
